import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { dockManagementRoutes } from './dock-management.routes';
import { dockManagement } from './dock-management.component';
import { CollapsiblePanelComponent } from '../../shared/collapsible-panel/collapsible-panel.component';
import { SharedModule } from '../../shared/module/shared.module';
import { DataTablesModule } from 'angular-datatables';

@NgModule({
	imports: [
		CommonModule,
        dockManagementRoutes,
        SharedModule,
        DataTablesModule
	],
	declarations: [
        dockManagement,
	],
	exports: [
        dockManagement,
	],
	providers: [
		
	]
})
export class dockManagementModule { }



// WEBPACK FOOTER //
// ./src/app/component/dock-management/dock-management.module.ts